
$( document ).ready(function() {
    if ($('#template').length === 1) {
        template.init();
    }
});

var template = {
    container: null,
    htmlEl: null,
    table: null,
    tableName: 'template-table',

    init: function() {
        this.htmlEl = $('.maingrid');
        this.container = $('#template');
        this.table = this.container.find('table');
        this.tableName = this.container.is('.template-table') ? 'template-tbl' : 'template-table';
        this.isFullTable = this.container.is('.template-table');
        if (!this.isFullTable) {
            exceltable.init(this.container);
            this.container
                .find('[data-depth="1"] .toggle-handler')
                .click(this.openSubPositions);
            this.registerInputs(this.container);
        }
        this.registerFixedHeader();
        this.initSearch();

        $('<div class="resizer"></div>').appendTo(this.container.find('th.resizable div,th.resizable a'));
        var resizableCols = this.container.find('th .resizer');

        template.initColumnsDropdown();
        template.setTableWidths(template.table);
        resizableCols.draggable({
            axis: "x",
            helper: "clone",
            appendTo: 'body',
            scroll: true,
            grid: [ 1, 0 ],
            targetEl: null,
            start: function(ev, dragging) {
                this.targetEl = $($(ev.currentTarget).parents('th'));
                dragging.helper.height(template.table.height()).css({
                    top: template.table.offset().top,
                    borderRight: '1px #444 dotted',
                    zIndex: 100
                });
            },
            stop: function(ev, drag) {
                var colEl = this.targetEl;
                var columnWidth = colEl.width();
                var dif = drag.position.left - drag.originalPosition.left;
                var newWidth = dif + columnWidth;
                if (newWidth < 30) newWidth = 30;
                template.setColumnWidth(colEl, newWidth);
            }
        });

        template.table.click(function(ev) {
            var row = $(ev.target).closest('tr');
            if (row.is('.header')) return true;
            template.selectTableRow(row);
            return true;
        });

        this.container.find('.header [data-find]').click(function() {
            var me = $(this);
            $('body').applyLoader(true, "Suche nächste leere Position");
            var selectedRowLft = template.table.find('.selected .lft').html();
            connection.getJson('/Template/FindNextPosition/'+template.container.attr('data-templateVersionId')+'?dataItemName='+me.attr('data-find')+'&startLftId='+selectedRowLft, {
                onSuccess: function(data) {
                    template.openTree(data.tree, data.openPrices);
                },
                onError: function() {
                    $('body').hideLoader();
                }
            });
        });
        this.container.find('table.body').show();
        this.container.find('.loader').remove();
    },

    selectTableRow: function(row) {
        template.table.find('tr.selected').removeClass('selected');
        row.addClass('selected');
    },

    registerFixedHeader: function() {
        template.container.scroll(function() {
            var scrollTop = template.container.scrollTop();
            $(template.table[0]).css({'position':'absolute','top':(scrollTop)+'px','z-index':1000});
        });
    },

    initColumnsDropdown: function() {
        var ddMenu = $('#dropdown-tbloptions ul');
        $.each(this.table.find('th.resizable'), function() {
            var thEl = $(this);
            var visible = parseInt(thEl.attr('data-visible')) == 1;
            $('<li><span><input style="width:auto;height:15px;" type="checkbox"'+(visible ? ' checked="checked"' : '')+' data-target="'+thEl.attr('data-res')+'" id="col-vis-'+thEl.attr('data-res')+'"> <label for="col-vis-'+thEl.attr('data-res')+'">'+thEl.find('div').text()+'</label></span></li>').appendTo(ddMenu);
        });
        ddMenu.find('input').on('change', function() {
            var me = $(this);
            var col = template.table.find('th[data-res='+me.attr('data-target')+']');
            if (me.is(':checked')) {
                connection.setUserOption(template.tableName + '-visible-' + col.attr('data-res'), 1);
                col.attr('data-visible', 1);
                template.setColumnWidth(col, col.attr('data-width'));
            } else {
                connection.setUserOption(template.tableName + '-visible-' + col.attr('data-res'), 0);
                col.attr('data-visible', 0);
                template.setTableWidths(template.table);
            }
        });
    },

    setColumnWidth: function(colEl, newWidth) {
        colEl.width(newWidth).attr('data-width', newWidth);
        //colEl.find('>div').width(newWidth-8);
        template.setTableWidths(template.table);

        connection.setUserOption(template.tableName + '-width-' + colEl.attr('data-res'), newWidth);
    },

    setTableWidths: function(container) {
        var totalWidth = 0;
        $.each(this.table.find('th'), function() {
            var thEl = $(this);
            var colNumber = thEl.attr('data-res');
            if (parseInt(thEl.attr('data-visible')) == 1) {
                container.find('.col' + colNumber).css('display', '');
                var width = parseInt(thEl.attr('data-width'));
                template.container.find('.header .col' + colNumber).css({'display': '', 'width': width});
                totalWidth += width + 2;
                var firstDataRow = $(container.find('tr[data-id]')[0]);
                if (thEl.data('res') == 0) {
                    firstDataRow.find('td.col0').css({ //  > div.input
                        width: width
                    });
                } else if (thEl.is('.resizable')) {
                    firstDataRow.find('td.col' + colNumber + '').css({ // > div.select
                        width: width
                    });
                    // firstDataRow.find('td.col' + colNumber + '').css({ // > div.input
                    //     width: width //- 8
                    // });
                } else {
                    firstDataRow.find('td.col' + colNumber + '').css({ // > div
                        width: width //- 8
                    });
                }
            } else {
                template.container.find('.header .col' + colNumber).css({'display': 'none'});
                container.find('.col' + colNumber).css('display', 'none');
            }
        });
        template.table.css({ width: totalWidth });
        template.table.next().css({ width: totalWidth });
        //template.container.css({ width: this.table.width() + 10 });
    },

    activateSortable: function(container) {
        template.lastDragEl = null;

        container.find('.drag-handle').draggable({
            // axis: "y",
            helper: "clone",
            containment: '#template',
            start: function(event, ui) {
                $(event.currentTarget).closest('tr').addClass('dragging');
                template.startNumberId = $(event.currentTarget).closest('[data-numberid]').attr('data-numberid');
            },
            drag: function(event, ui) {
                var toEl = template.lastDragEl;
                if (toEl != null) {
                    console.log('draging');
                    var fromEl = $(event.target);
                    var fromRow = fromEl.closest('tr');
                    var toRow = toEl.closest('tr');
                    if (fromRow.is('[data-obj=PositionPrice]') && !toRow.is("[data-parent='"+fromRow.attr('data-parent')+"']")) {
                        return;
                    }

                    var $newPosY = toEl.offset().top - event.clientY;
                    template.table.find('.dndbefore').removeClass('dndbefore');
                    template.table.find('.dndafter').removeClass('dndafter');
                    if (Math.abs($newPosY) < 10) toEl.addClass('dndbefore');
                    if (Math.abs($newPosY) > 20) toEl.addClass('dndafter');
                }
            },
            stop: function(event, ui) {
                var fromEl = $(event.target);
                var toEl = template.lastDragEl;
                if (toEl == null) {
                    template.moveEnded(true);
                    return;
                }
                var row = toEl.parents('tr');
                if (toEl == null || fromEl.parent().attr('data-numberid') == toEl.attr('data-numberid')) {
                    template.moveEnded(true);
                    return;
                }

                var fromRow = fromEl.closest('tr');
                var moveAfter = true, newParentId, newSequence, newDepth;
                if (toEl.is('.dndbefore')) {
                    // move before item
                    moveAfter = false;
                    newParentId = row.attr('data-parent');
                    newSequence = parseInt(template.table.find('[data-parent=' + newParentId + ']').index(row)) + 1;
                    newDepth = parseInt(row.attr('data-depth'));
                } else if (toEl.is('.dndafter')) {
                    // move after item
                    newParentId = row.attr('data-parent');
                    newSequence = parseInt(template.table.find('[data-parent=' + newParentId + ']').index(row)) + 1;
                    newDepth = parseInt(row.attr('data-depth'));
                } else {
                    // move inside item
                    newParentId = row.attr('data-id');
                    newSequence = 0;
                    newDepth = parseInt(row.attr('data-depth')) + 1;
                }

                if (fromRow.is('[data-obj=Position]')) {
                    messaging.askYesNo('Position verschieben?', 'Position <b>' + fromRow.find('[data-name="ArchiNumber"]').val() + ' ' + fromRow.find('[data-name="Name"]').val() + '</b> verschieben?', function(dialogEl) {
                        dialogEl.addClass('wait').html('Der Vorgang kann einige Sekunden dauern...');

                        if (moveAfter) { fromRow.insertAfter(toEl.closest('tr')); } else { fromRow.insertBefore(toEl.closest('tr')); };
                        fromRow.attr('data-parent', newParentId);
                        fromRow.attr('data-depth', newDepth);
                        var siblings = template.table.find('[data-parent=' + newParentId + ']');
                        var sortList = {};
                        $.each(siblings, function(i, el) {
                            sortList[$(el).attr('data-id')] = i;
                        });

                        $.ajax({
                            url: '/Template/MovePosition/' + fromRow.attr('data-id'),
                            data: {
                                // sequence: newSequence,
                                sortList: sortList,
                                parentId: newParentId
                            },
                            timeout: 50000,
                            success: function (data) {

                                messaging.showGlobalMessage('success', null, 'Die Position wurde geändert.');
                            },
                            complete: function () {
                                template.moveEnded(true);
                                // $(dialogEl).dialog("close");
                            },
                            error: function () {
                                messaging.showGlobalMessage('danger', null, 'Die Position konnte nicht verschoben werden.');
                                fromRow.insertAfter(dnd.currentPreviousItem);
                            }
                        });
                    }, function() {
                        template.moveEnded(true);
                    });
                } else {
                    $.ajax({
                        url: '/Template/MovePricePosition/' + fromRow.attr('data-id'),
                        data: {
                            sequence: newSequence
                        },
                        timeout: connection.defaultTimeout,
                        success: function (data) {
                            if (moveAfter) { fromRow.insertAfter(toEl.closest('tr')); } else { fromRow.insertBefore(toEl.closest('tr')); };
                            messaging.showGlobalMessage('success', null, 'Die Preisposition wurde geändert.');
                        },
                        complete: function () {
                            template.moveEnded(true);
                        },
                        error: function () {
                            messaging.showGlobalMessage('danger', null, 'Die Preisposition konnte nicht verschoben werden.');
                            fromRow.insertAfter(dnd.currentPreviousItem);
                        }
                    });
                }
            }
        });

        container.find('.option-bar').droppable({
            over: function(event, ui) {
                var toEl = $(this).closest('[data-numberid]');
                var fromEl = $(ui.helper);
                var fromRow = fromEl.closest('tr');
                var toRow = toEl.closest('tr');
                if (fromRow.is('[data-obj=PositionPrice]') && !toRow.is("[data-parent='"+fromRow.attr('data-parent')+"']")) {
                    return;
                }
                template.lastDragEl = toEl;
                if (toEl.length === 1 && toEl.attr('data-numberid') !== template.startNumberId) {
                    template.table.find('.dndactive').removeClass('dndactive');
                    toEl.addClass('dndactive');
                }
            },
            out: function() {
                template.moveEnded();
            }
        });
    },

    moveEnded: function(finish) {
        template.lastDragEl = null;
        template.table.find('.dndactive').removeClass('dndactive');
        template.table.find('.dndbefore').removeClass('dndbefore');
        template.table.find('.dndafter').removeClass('dndafter');
        if (finish) template.table.find('.dragging').removeClass('dragging');
    },

    openTree: function(treeIds, openPrices, openedEl) {
        if (treeIds.length == 0) {
            if (openPrices && !openedEl.hasClass('opened')) {
                template.openPricePositionsFrom(openedEl);
            }
            $('body').hideLoader();
            if (openedEl != null) {
                template.container.parent().animate({
                    scrollTop: openedEl.position(template.container.parent()).top - 26
                }, function() {
                    template.selectTableRow(openedEl);
                    openedEl.find('.value').css({ backgroundColor: '#f00' }).animate({
                        backgroundColor: '#E29570'
                    }, function() {
                        openedEl.find('.value').css({ backgroundColor: '' });
                        openedEl.addClass('slidein-active');
                    });
                });
            }
            return;
        }

        var id = treeIds.shift();
        var el = $('#template tr[data-id='+id+']');
        if (el.hasClass('leaf')) {
            template.openTree(treeIds, openPrices, el);
            return;
        }
        if (el.hasClass('opened')) {
            template.openTree(treeIds, openPrices, el);
        } else {
            template.openSubPositionsFrom(el, function() {
                template.openTree(treeIds, openPrices, el);
            });
        }
    },

    openSubPositions: function() {
        var me = $(this).parents('tr');
        template.openSubPositionsFrom(me);
    },

    openSubPositionsFrom: function(rowEl, onSuccess) {
        var me = rowEl;
        if (me.hasClass('progressing')) return;
        if (!me.hasClass('opened')) {
            $.ajax({
                url: '/Template/LoadPart/' + me.attr('data-id'),
                timeout: connection.defaultTimeout,
                beforeSend: function() {
                    progress.startProgress();
                    me.addClass('progressing');
                },
                success: function(data) {
                    if (me.hasClass('opened')) return;
                    me.addClass('opened');
                    var content = $(data.trim());
                    template.setTableWidths(content);
                    me.after(content);
                    template.container
                        .find('[data-parent='+me.attr('data-id')+']')
                        .attr('data-depth', parseInt(me.attr('data-depth')) + 1);
                    //
                    exceltable.init(content);
                    template.registerInputs(content);
                    if (onSuccess) onSuccess();
                },
                error: function(data) {
                    try {
                        var message = (data.responseJSON.error) ? data.responseJSON.error : 'Fehler beim öffnen einer Position.' ;
                        messaging.showGlobalMessage('danger', null, message);
                    } catch (e) {
                        messaging.showGlobalMessage('danger', null, 'Fehler beim öffnen einer Position.');
                    }
                    if (onSuccess) onSuccess();
                },
                complete: function() {
                    progress.endProgress();
                    me.removeClass('progressing');
                }
            });
        } else {
            template.closePart(me);
            progress.endProgress();
            me.removeClass('progressing');
        }
    },

    positionsList: [],
    openAllSubPositions: function(tr) {
        template.positionsList = [];
        $('body').applyLoader(true, "Positionen werden geöffnet ...");
        if (tr.hasClass('opened')) {
            template.closePart(tr);
        }
        template.openAllSubPositionsRecursion(tr);
    },

    openAllSubPositionsRecursion: function(tr) {
        if (tr.is('.node')) {
            template.openSubPositionsFrom(tr, function () {
                $.merge(template.positionsList, $('.position[data-parent="' + tr.attr('data-id') + '"]'));
                $('body').changeLoader(`${template.positionsList.length} Positionen werden geöffnet ...`);
                if (template.positionsList.length > 0) {
                    template.openAllSubPositionsRecursion($(template.positionsList.shift()));
                } else {
                    $('body').hideLoader();
                }
            });
        } else {
            template.openPricePositionsFrom(tr, function() {
                if (template.positionsList.length > 0) {
                    template.openAllSubPositionsRecursion($(template.positionsList.shift()));
                } else {
                    $('body').hideLoader();
                }
            });
        }
    },

    openPricePositions: function() {
        var me = $(this).parents('tr');
        template.openPricePositionsFrom(me);
    },

    openPricePositionsFrom: function(rowEl, onSuccess) {
        var me = rowEl;
        progress.startProgress();
        if (!me.hasClass('opened')) {
            $.ajax({
                url: '/Template/LoadPricePart/' + me.attr('data-id'),
                timeout: connection.defaultTimeout,
                success: function(data) {
                    me.addClass('opened');
                    var content = $(data.trim());
                    template.setTableWidths(content);
                    me.after(content);
                    template.container
                        .find('[data-parent='+me.attr('data-id')+']')
                        .attr('data-depth', parseInt(me.attr('data-depth')) + 1);
                    content.find('[data-slidein]').off('click').click(template.openPositionDetails);
                    //
                    exceltable.init(content);
                    template.registerInputs(content);
                    if (onSuccess) onSuccess();
                },
                complete: function() {
                    progress.endProgress();
                }
            });
        } else {
            template.closePart(me);
            progress.endProgress();
        }
    },

    openPositionDetails: function() {
        var me = $(this);
        $('.slidein-active').removeClass('slidein-active');
        $('.slidein-tree-active').removeClass('slidein-tree-active');
        me.parents('tr').addClass('slidein-active');
        slidein.openUrl(me.attr('data-slidein'), function(element) {
        });
    },

    closePart: function(partEl) {
        var depth = parseInt(partEl.attr('data-depth'));
        var next = partEl.next();
        while (depth < parseInt(next.attr('data-depth'))) {
            var theNext = next.next();
            next.remove();
            next = theNext;
        }
        partEl.removeClass('opened');
    },

    registerInputs: function(container) {
        var event = new CustomEvent('template.part-loaded', { bubbles: false, detail: { container: container} });
        document.dispatchEvent(event);

        // container.find('.options-handler').click(function() {
        //     var me = $(this);
        //     if (me.find('.dd-select').length === 0) {
        //         var handler = $(this).find('[id^=options-]');
        //         var ddOptions = [
        //             {
        //                 text: 'löschen', value: 2, callback: function() {
        //                     template.deletePosition($(me.parents('tr')));
        //                 }
        //             }, {
        //                 text: 'Hinzufügen oberhalb', value: 3, callback: function() {
        //                     template.addPosition($(me.parents('tr')), 'before');
        //                 }
        //             }, {
        //                 text: 'Hinzufügen unterhalb', value: 3, callback: function() {
        //                     template.addPosition($(me.parents('tr')), 'after');
        //                 }
        //             }, {
        //                 text: 'Position kopieren', value: 5, callback: function() {
        //                     template.copyPosition($(me.parents('tr')));
        //                 }
        //             }, {
        //                 text: 'Unterposition hinzufügen', value: 4, callback: function() {
        //                     template.addPosition($(me.parents('tr')), 'inside');
        //                 }
        //             }, {
        //                 text: 'Neu laden', value: 6, callback: function() {
        //                     template.reloadPosition($(me.parents('tr')));
        //                 }
        //             }, {
        //                 text: 'Alle Positionen öffnen', value: 7, callback: function() {
        //                     template.openSubPositionsRecursive($(me.parents('tr')));
        //                 }
        //             }, {
        //                 text: 'Nach Excel exportieren', value: 4, callback: function() {
        //                     template.exportPosition($(me.parents('tr')));
        //                 }
        //             }
        //         ];
        //         if (me.hasClass('leaf')) {
        //             ddOptions.push({
        //                 text: 'Preis-Position hinzufügen', value: 5, callback: function() {
        //                     template.addPricePosition($(me.parents('tr')));
        //                 }
        //             });
        //         }
        //         handler.ddslick({
        //             data: ddOptions,
        //             handler: me,
        //             selectText: '-',
        //             doSelection: false,
        //             onInitialized: function() {
        //                 me.find('.dd-select').hide();
        //                 me.find('>div').removeClass('d-none');
        //                 me.find('.dd-option').css({ width: '200px' });
        //             },
        //             onOpen: function(options) {
        //                 options.css({top: '0px'});
        //             },
        //             onSelected: function (data) {
        //                 data.selectedData.callback();
        //             }
        //         });
        //         setTimeout(function() {
        //             handler.ddslick("open");
        //         }, 50);
        //     }
        //     return false;
        // });
        // container.find('.price-options-handler').click(function() {
        //     debugger;
        //     var me = $(this);
        //     if (me.find('.dd-select').length === 0) {
        //         var handler = $(this).find('[id^=options-]');
        //         var ddOptions = [
        //             {
        //                 text: 'löschen', value: 2, callback: function() {
        //                     template.deletePricePosition($(me.parents('tr')));
        //                 }
        //             }
        //         ];
        //         handler.ddslick({
        //             data: ddOptions,
        //             handler: me,
        //             selectText: '-',
        //             doSelection: false,
        //             onInitialized: function() {
        //                 me.find('.dd-select').hide();
        //                 me.find('>div').removeClass('d-none');
        //                 me.find('.dd-option').css({ width: '200px' });
        //             },
        //             onOpen: function(options) {
        //                 options.css({top: '5px'});
        //             },
        //             onSelected: function (data) {
        //                 data.selectedData.callback();
        //             }
        //         });
        //         setTimeout(function() {
        //             handler.ddslick("open");
        //         }, 50);
        //     }
        //     return false;
        // });


        container.find('.toggle-handler').off('click').on('click', template.openSubPositions);
        container.find('.toggle-leaf-handler').off('click').on('click', template.openPricePositions);
        container.find('.marker-checkboxes .marker-checkbox-ctl').click(function() {
            var me = $(this);
            debugger;
            connection.loadJson(me.parent('[data-url]').attr('data-url') + '&' + me.attr('data-params'), null, function(data) {
                if (data.isActive) {
                    me.addClass('active');
                } else {
                    me.removeClass('active');
                }
                // update other fields
                if (data.fields != null) {
                    $.each(data.fields, function(key, isActive) {
                        if (isActive) {
                            $('#'+key).addClass('active');
                        } else {
                            $('#'+key).removeClass('active');
                        }
                    });
                }
            }, null);
        });
        template.activateSortable(container);
        var fields = container.find('input,textarea,[contenteditable]');
        connection.applyValueChange(fields, {
            onChange: function(formEl, oldValue, value) {
                template.savePosition(formEl, value);
            }
        });
        $.each(container.find('input,textarea'), function(i, el) {
            $(el).attr('data-val', $(el).val());
        });
        container.find('[data-slidein]').off('click').click(template.openPositionDetails);
        $.each(container.find('input'), function(i, el) {
            $(el).attr('data-val', $(el).val());
        });
    },

    savePosition: function(inputEl, value) {
        var positionLine = inputEl.parents('tr');
        template.savePositionField(positionLine.attr('data-id'), positionLine.attr('data-obj'), inputEl.attr('data-name'), value);
    },

    savePositionField: function(positionId, objName, fieldName, value) {
        var postData = {
            objName: objName,
            name: fieldName,
            value: value
        };
        connection.executeSaveTask('/Template/SavePosition/' + positionId, postData, function(data) {
            //
        }, function() {
            var field = $('#'+fieldName+'-'+positionId);
            field.focus();
            messaging.showGlobalMessage("danger", null, "Der Wert konnte nicht gespeichert werden.");
        });
    },

    // Positions part

    reloadPosition: function(rowEl, options) {
        options = options || {};
        var me = rowEl;
        if (me.hasClass('progressing')) return;

        if (me.hasClass('opened')) {
            template.closePart(me);
            progress.endProgress();
        }

        $.ajax({
            url: '/Template/ReloadPart/' + me.attr('data-id'),
            timeout: connection.defaultTimeout,
            beforeSend: function() {
                progress.startProgress();
                me.addClass('progressing');
            },
            success: function(data) {
                var content = $(data.trim());
                template.setTableWidths(content);
                me.after(content);
                template.container
                    .find('[data-parent='+me.attr('data-id')+']')
                    .attr('data-depth', parseInt(me.attr('data-depth')) + 1);
                content.attr('data-depth', parseInt(me.attr('data-depth')));
                //
                exceltable.init(content);
                template.registerInputs(content);
                me.remove();
                if (options.onSuccess) options.onSuccess(content);
            },
            error: function(data) {
                try {
                    var message = (data.responseJSON.error) ? data.responseJSON.error : 'Fehler beim öffnen einer Position.' ;
                    messaging.showGlobalMessage('danger', null, message);
                } catch (e) {
                    messaging.showGlobalMessage('danger', null, 'Fehler beim öffnen einer Position.');
                }
                if (onSuccess) onSuccess();
            },
            complete: function() {
                progress.endProgress();
                me.removeClass('progressing');
            }
        });
    },

    exportPosition: function(referenceElement) {
        var href = '/TemplateExport/ExportToExcel/'+template.container.attr('data-templateversionid')+'?RootPositionId='+referenceElement.attr('data-id');
        progress.startBackground(href, {
            onFinished: function (data) {
                messaging.showPermanentGlobalMessage('success', null, '<a href="'+data.filepath+'">Export herunterladen</a>', -1);
            },
            onError: function () {
                messaging.showPermanentGlobalMessage('danger', null, 'Das PDF konnte nicht erstellt werden.', -1);
            }
        });
    },

    addPosition: function(referenceElement, position) {
        var seq = 0;
        var parentId = 0;
        if (position === 'inside') {
            seq = 1;
            parentId = referenceElement.attr('data-id');
        } else {
            parentId = referenceElement.attr('data-parent');
            if (position === 'after') {
                seq = parseInt(template.table.find('[data-parent='+parentId+']').index(referenceElement)) + 2;
            }
            if (position === 'before') {
                seq = parseInt(template.table.find('[data-parent='+parentId+']').index(referenceElement)) + 1;
                if (seq < 1) {
                    seq = 1;
                }
            }
        }

        template.container.applyLoader(true, "Position wird hinzugefügt ...");
        $.ajax({
            url: '/Template/EmptyPosition',
            timeout: connection.defaultTimeout,
            data: {
                templateVersionId: template.container.attr('data-templateversionid'),
                parentPositionId: parentId,
                sequence: seq
            },
            success: function(data) {
                template.reloadPosition(referenceElement, {
                    onSuccess: function(reloadedRowEl) {
                        var el = $('<table>'+data.trim()+'</table>').find('tr');
                        if (position == 'inside') {
                            template.openSubPositionsFrom(reloadedRowEl);
                        } else if (position == 'after') {
                            el.attr('data-depth', reloadedRowEl.attr('data-depth'));
                            el.insertAfter(reloadedRowEl);
                        } else {
                            el.attr('data-depth', reloadedRowEl.attr('data-depth'));
                            el.insertBefore(reloadedRowEl);
                        }
                        template.registerInputs(el);
                        template.setTableWidths(el);
                    }
                });
            },
            complete: function() {
                template.container.hideLoader();
            }
        });
    },

    copyPosition: function(referenceElement) {
        messaging.askYesNo('Position kopieren', 'Willst du die Position mit allen Unterpositionen und Preisen kopieren?', function() {
            var positionId = referenceElement.attr('data-id');
            $('body').applyLoader(true, "Position wird kopiert<br/>Je nach Umfang der Position kann dies eine Weile dauern ...");
            $.ajax({
                url: '/Template/CopyPosition/' + positionId,
                type: 'post',
                dataType: 'json',
                timeout: connection.defaultTimeout,
                success: function(data) {
                    if (referenceElement.hasClass('opened')) {
                        template.closePart(referenceElement);
                    }
                    var content = $(data.view.trim());
                    content.attr('data-depth', referenceElement.attr('data-depth'));
                    referenceElement.after(content);
                    template.registerInputs(content);
                    messaging.showGlobalMessage("success", null, "Die Position wurde kopiert.");
                },
                error: function(data) {
                    if (data.statusText == 'timeout') {
                        messaging.showPermanentGlobalMessage('danger', 'Timeout', 'Zeitüberschreitung die Aktion läuft auf dem Server weiter... Schliesse und öffne die obere Position, sobald die Kopie fertig ist, wird sie erscheinen.');
                        return;
                    }
                    messaging.showPermanentGlobalMessage('danger', 'Fehler', connection.getErrorMessageOf(data, 'Fehler beim kopieren der Position.'));
                },
                complete: function() {
                    $('body').hideLoader();
                }
            });
        }, null);
    },

    deletePosition: function(positionRow) {
        messaging.askYesNo('Position löschen', 'Willst du diese Position mit allen Unterpositionen löschen?', function() {
            var positionId = positionRow.attr('data-id');
            $('body').applyLoader(true, 'Position wird gelöscht<br/>Je nach Umfang der Position kann dies eine Weile dauern ...');
            $.ajax({
                url: '/Template/DeletePosition/' + positionId,
                type: 'post',
                dataType: 'json',
                timeout: connection.defaultTimeout,
                success: function() {
                    if (positionRow.hasClass('opened')) {
                        template.closePart(positionRow);
                    }
                    positionRow.remove();
                    messaging.showGlobalMessage("success", null, "Die Position wurde gelöscht.");
                },
                error: function(data) {
                    if (data.statusText == 'timeout') {
                        messaging.showPermanentGlobalMessage('danger', 'Timeout', 'Zeitüberschreitung die Aktion läuft auf dem Server weiter... Schliesse und öffne die obere Position, sobald die Position gelöscht wurde verschwindet sie hier.');
                        return;
                    }
                    messaging.showGlobalMessage("danger", null, "Die Position konnte nicht gelöscht werden: " + data.error);
                },
                complete: function() {
                    $('body').hideLoader();
                }
            });
        }, null);
    },

    //# Price Positions

    addPricePosition: function(referenceElement) {
        $.ajax({
            url: '/Template/EmptyPricePosition',
            timeout: connection.defaultTimeout,
            data: {
                positionId: referenceElement.attr('data-id')
            },
            success: function(data) {
                var el = $('<table>'+data.trim()+'</table>').find('tr');
                if (referenceElement.hasClass('opened')) {
                    el.attr('data-depth', parseInt(referenceElement.attr('data-depth')) + 1);
                    var lastPriceElement = template.table.find('.positionprice[data-parent='+referenceElement.attr('data-id')+']').last();
                    el.insertAfter(lastPriceElement);
                    template.registerInputs(el);
                    template.setTableWidths(el);
                } else {
                    template.openPricePositionsFrom(referenceElement);
                }
            },
            complete: function() {
            }
        });
    },

    deletePricePosition: function(positionRow) {
        messaging.askYesNo('Preis-Position löschen', 'Willst du diese Preis-Position löschen?', function() {
            var pricePositionId = positionRow.attr('data-id');
            var task = {
                run: function(onComplete) {
                    $.ajax({
                        url: '/Template/DeletePricePosition/' + pricePositionId,
                        type: 'post',
                        dataType: 'json',
                        timeout: connection.defaultTimeout,
                        success: function() {
                            positionRow.remove();
                            messaging.showGlobalMessage("success", null, "Die Preis-Position wurde gelöscht.");
                        },
                        error: function(data) {
                            messaging.showGlobalMessage("danger", null, "Die Preis-Position konnte nicht gelöscht werden: " + data.error);
                        },
                        complete: function() {
                            if (onComplete != null) onComplete();
                        }
                    });
                }
            };
            taskQueue.add(task);
        }, null);
    },

    searchTimer: null,
    initSearch: function(inputEl, callback) {
        $.each(inputEl || $('input.pos-search'), function(index, el) {
            var field = $(el);
            if (field.parent().is('.autocompleter-container')) return;

            var groupAppend = field.next('.input-group-append');
            var container = $('<div class="input-group autocompleter-container"></div>');
            field.wrap(container);
            container = field.parent('div');
            var displayEl = field.clone();
            displayEl.attr('id', displayEl.attr('id') + 'display' + Math.ceil(Math.random() * 200))
                .attr('name', '')
                .attr('data-val', field.attr('fullvalue'))
                .attr('placeholder', 'Suche mit Enter starten..')
                .val(field.attr('fullvalue'));
            field.addClass('d-none').after(displayEl);
            $('<div class="input-group-prepend loader-indicator"><span class="input-group-text"><i class="fa bi-search"></i><i class="fa fa-spinner fa-spin"></i></span></div>').insertAfter(field);
            var dropdownEl = $('<div class="dropdown-container dd-options pos-search ctl-autocompleter-options"></div>').css({'position': 'absolute'}).hide();
            displayEl.after(dropdownEl);

            displayEl.on('keydown', function (ev) {
                if (ev.keyCode === $.ui.keyCode.ENTER) return false;
            });
            displayEl.on('keyup', function(ev) {
                var page = 0;
                if (template.searchTimer) clearTimeout(template.searchTimer);
                template.searchTimer = setTimeout(function () {
                    template.dropdownPositioning(container, dropdownEl);
                    dropdownEl.show().html('suche läuft ...');
                    template.doSearch(container, displayEl, dropdownEl, page, callback);
                }, 1000);
                if (ev.keyCode === $.ui.keyCode.ENTER) {
                    ev.preventDefault();
                    if (template.searchTimer) clearTimeout(template.searchTimer);
                    template.dropdownPositioning(container, dropdownEl);
                    dropdownEl.show().html('suche läuft ...');
                    template.doSearch(container, displayEl, dropdownEl, page, callback);
                    $('body').on('click.search', function (ev) {
                        if ($(ev.target).parents('.autocompleter-container').length === 0) {
                            template.closeSearch(displayEl, dropdownEl);
                        }
                    });
                    return false;
                }
                // if (ev.keyCode === $.ui.keyCode.ENTER) {
                //     dropdownEl.css({
                //         'width': container.outerWidth()
                //     }).position({
                //         'my': 'top left',
                //         'target': 'bottom left'
                //     });
                //     dropdownEl.show().html('suche läuft ...');
                //     template.doSearch(container, displayEl, dropdownEl, page);
                //     $('body').on('click.search', function(ev) {
                //         if ($(ev.target).parents('.autocompleter-container').length === 0) {
                //             template.closeSearch(displayEl, dropdownEl);
                //         }
                //     });
                // }
                if (ev.keyCode === $.ui.keyCode.ESCAPE) {
                    template.closeSearch(displayEl, dropdownEl);
                }
            });
            if (groupAppend.length > 0) {
                groupAppend.appendTo(field.parent());
            }
            displayEl.focus();
        });
    },

    dropdownPositioning: function (container, dropdownEl) {
        dropdownEl.css({
            'width': container.outerWidth()
        }).position({
            'my': 'top left',
            'target': 'bottom left'
        });
    },

    doSearch: function(container, field, dropdownEl, page) {
        container.addClass('autocompleter-loading');
        connection.getJson(field.attr('data-url'), {
            timeout: 10000,
            data: {
                templateId: field.attr('data-templateId'),
                search: field.val(),
                page: page
            },
            onSuccess: function(data) {
                container.removeClass('autocompleter-loading');
                var list = $('<ul class=""></ul>');
                dropdownEl.empty();
                list.appendTo(dropdownEl);
                if (data.data.length == 0) {
                    $('<li class="empty">Keine Positionen gefunden ...</li>').appendTo(list);
                } else {
                    $('<div class="paging"><i class="fa bi-arrow-left disabled prev"></i> <i class="fa bi-arrow-right disabled next"></i> <span>'+(page + 1)+'/'+data.pages+' Seiten</span> <i class="fa bi-x-lg"></i></div>').prependTo(dropdownEl);
                    if (page > 0) {
                        container.find('.prev').removeClass('disabled').on('click', function () {
                            template.doSearch(container, field, dropdownEl, page - 1);
                        });
                    }
                    if (data.hasMorePages) {
                        container.find('.next').removeClass('disabled').on('click', function () {
                            template.doSearch(container, field, dropdownEl, page + 1);
                        });
                    }
                    container.find('.bi-x-lg').click(function() {
                        template.closeSearch(field, dropdownEl);
                    });

                    for (var i = 0; i < data.data.length; i++) {
                        var item = data.data[i];
                        var hint = (item.hint != undefined) ? ' <span class="hint">' + item.hint + '</span>' : '';
                        $('<li data-treeIds="'+item.value+'">')
                            .append('<a class="dd-option">' + item.label + hint + '</a>')
                            .click(function() {
                                template.closeSearch(field, dropdownEl);
                                var treeIds = $(this).attr('data-treeIds').split(',');
                                $('body').applyLoader(true, 'Position wird geöffnet');
                                template.openTree(treeIds, false);
                            })
                            .appendTo(list);
                    }
                }
            },
            onError: function() {
                container.removeClass('autocompleter-loading');
                dropdownEl.html("Die Suche wurde abgebrochen, versuche es nochmals...");
            }
        });
    },

    closeSearch: function(field, dropdownEl) {
        field.val('');
        dropdownEl.empty().hide();
        $('body').off('click.search');
    }

};
window.template = template;
